import Model from './Model'

export default class CompanyNew extends Model
{
    static async all () {
        const data = await Http.get(route('api.v2.organization.companies.list'))
        return this.make(data)
    }

    setAttributes(attributes) {
        super.setAttributes(attributes);
        let tokens = [
            attributes.name,
        ]
        this.tokens = tokens.join('|').toLowerCase();
    }
}
